import React from "react";
import {
 
  TestimonialContainerClientAvatar,
  
  TestimonialContainerClientAvatarImage,
 
  TestimonialsWrapper,
} from "./styles";


import { Pagination } from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

const Testimonials = ({ resim1, resim2, resim3, resim4}) => {
  const data = [{
    avatar: resim1
  },
  {
    avatar: resim2
  },{
    avatar: resim3
  },
  {
    avatar: resim4 
  }
];
  return (
    <TestimonialsWrapper>
      <Swiper
        modules={[Pagination]}
        spaceBetween={40}
        slidesPerView={1}
        pagination={{ clickable: true }}
        className="container testimonials__container"
      >
        {data.map(({ avatar, name, review }, index) => (
          <SwiperSlide key={index} className="testimonial">
             {avatar ?
            <TestimonialContainerClientAvatar>
             
              <TestimonialContainerClientAvatarImage src={avatar} alt="" />
             
            </TestimonialContainerClientAvatar>
            :""}
         
          </SwiperSlide>
        ))}
      </Swiper>
    </TestimonialsWrapper>
  );
};

export default Testimonials;
